
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import hotelRoomImg1 from "../../../images/aaaservices/point-of-sale.webp";
// import hotelRoomImg2 from "../../../images/products/products.png";
// import hotelRoomImg3 from "../../../images/aaaservices/groceries.png";
// import { useLoader } from "../../../context/LoaderProvider";

// const cardData = [
//   {
//     image: hotelRoomImg1,
//     location: "Food & Beverages",
//     description:
//       "From fine dining and quick-service restaurants to cafes, bakeries, juice bars, and specialty food stores, Maamaas empowers you to showcase your menu with stunning visuals, manage orders seamlessly—including dine-in, takeaway, and delivery—and reach more customers in your area to grow your brand.",
//     verticalKey: "FOOD_AND_BEVERAGES",
//   },
//   // {
//   //   image: hotelRoomImg2,
//   //   location: "Catering & Services",
//   //   description:
//   //     "Whether you provide personal catering, corporate event catering, or operate a company cafeteria, Maamaas helps you present your catering packages and customized menu options to potential clients, accept bookings online effortlessly, and build trust through customer ratings and reviews.",
//   //   verticalKey: "CATERINGS_SERVICES",
//   // },
//   // {
//   //   image: hotelRoomImg3,
//   //   location: "Fresh & Groceries",
//   //   description:
//   //     "From courier and delivery services to wholesale suppliers and inventory businesses, Maamaas streamlines your operations by managing orders efficiently, tracking deliveries and shipments in real time, and enabling smooth communication with customers and partners.",
//   //   verticalKey: "FRESH_GROCERIES",
//   // },
// ];

// const DemoBooking = () => {
//   const navigate = useNavigate();
//   const { showLoader, hideLoader } = useLoader();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [vendorData, setVendorData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [selectedVertical, setSelectedVertical] = useState("");

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//   });

//   const openModal = (vertical) => {
//     setSelectedVertical(vertical);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       if (!formData.name || !formData.email || !formData.phone) {
//         alert("Please fill in all required fields (Name, Email, Phone).");
//         return;
//       }

//       const payload = {
//         vendorId: vendorData?.vendorId || 0,
//         parentId: null,
//         name: formData.name.trim(),
//         email: formData.email.trim(),
//         mobileNumber: formData.phone.trim(),
//         role: "ROLE_VENDOR",
//         businessVerticals: [selectedVertical],
//         registerTime: ""
//       };

//       setLoading(true);
//       showLoader();

//       const res = await fetch(
//         "https://backend.maamaas.com/subscription/api/vendor/enquiry",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const responseData = await res.json().catch(() => ({}));

//       setLoading(false);

//       if (!res.ok) {
//         console.error("❌ Server error:", responseData);
//         alert(`Submission failed: ${responseData.message || "Unknown error"}`);
//         return;
//       }

//       if (responseData.vendorId) {
//         localStorage.setItem("vendorId", responseData.vendorId);
//       }

//       alert("✅ Enquiry submitted successfully!");
//       setFormData({ name: "", phone: "", email: "" });
//       closeModal();
//       navigate("/subscriptionpage");
//     } catch (err) {
//       setLoading(false);
//       console.error("❌ Error submitting form:", err);
//       alert("Something went wrong. Please try again later.");
//     } finally {
//       hideLoader();
//     }
//   };

//   return (
//     <section id="what-we-do">
//       <style>
//         {`
//           .main-container {
//             background-color:#2a0947;
//             color: #fff;
//             padding: 20px;
//             text-align: center;
//             margin-top:20px;
//             font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           }

//           .cards-container {
//             display: flex;
//             justify-content: center;
//             flex-wrap: wrap;
//             gap: 20px;
//             padding: 20px 0;
//           }

//           /* ✅ For large screens (above 1000px) — show 3 cards per row */
//           @media (min-width: 1000px) {
//             .cardss {
//               width: calc(33.33% - 40px);
//               max-width: 350px;
//             }
//           }

//           /* ✅ Between 768px–999px — 2 cards per row */
//           @media (min-width: 768px) and (max-width: 999px) {
//             .cardss {
//               width: calc(50% - 30px);
//             }
//           }

//           /* ✅ Below 768px — 1 card per row */
//           @media (max-width: 767px) {
//             .cardss {
//               width: 100%;
//             }
//           }

//           .cardss {
//             background: #fff;
//             border-radius: 20px;
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             overflow: hidden;
//             padding: 20px 10px;
//             color: #000;
//             position: relative;
//             box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//           }

//           .image-container {
//             width: 100%;
//             height: 180px;
//           }

//           .image-container img {
//             width: 100%;
//             height: 100%;
//             object-fit: cover;
//             border-radius: 12px;
//           }

//           .description {
//             padding: 10px 0;
//             font-size: 14px;
//             text-align: center;
//             min-height: 60px;
//             font-weight: bold;
//           }

//           .location-overlays {
//             position: absolute;
//             bottom: 19px;
//             left: 30%;
//             transform: translateX(-50%);
//             background: #2a0947;
//             color: white;
//             padding: 8px 8px;
//             border-radius: 10px;
//             font-size: 14px;
//             font-weight: bold;
//             z-index: 1;
//             transition: background 0.3s, color 0.3s;
//           }

//           .location-overlays:hover {
//             background: #ffbe64;
//             color: black;
//           }

//           .book-now-btn {
//             margin-top: auto;
//             padding: 8px 6px;
//             background: #2a0947;
//             color: rgb(255 225 36);
//             border: none;
//             border-radius: 8px;
//             font-size: 14px;
//             font-weight: bold;
//             cursor: pointer;
//             // margin-left: 153px;
//           }

//           .book-now-btn:hover {
//             background-color: #2a0947;
//             color: white;
//           }

//           /* ✅ IMPROVED MODAL STYLES - FULLY RESPONSIVE */
//           .modal {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             bottom: 0;
//             background: rgba(0,0,0,0.5);
//             width: 100vw;
//             height: 100vh;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 9999;
//             padding: 20px;
//             box-sizing: border-box;
//           }

//           .modal-box {
//             background: #fff;
//             color: #000;
//             padding: 30px;
//             border-radius: 12px;
//             width: 90%;
//             max-width: 450px;
//             min-height: 300px;
//             box-shadow: 0 20px 40px rgba(0,0,0,0.3);
//             position: relative;
//             margin: 0 auto;
//           }

//           .modal-box input {
//             width: 100%;
//             padding: 14px 16px;
//             margin-bottom: 16px;
//             border-radius: 8px;
//             border: 1px solid #ddd;
//             box-sizing: border-box;
//             font-size: 16px;
//             transition: border-color 0.3s;
//           }

//           .modal-box input:focus {
//             border-color: #2a0947;
//             outline: none;
//           }

//           .modal-close {
//             position: absolute;
//             top: 15px;
//             right: 20px;
//             font-size: 28px;
//             background: none;
//             border: none;
//             cursor: pointer;
//             color: #666;
//             width: 35px;
//             height: 35px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             border-radius: 50%;
//             transition: all 0.3s;
//           }

//           .modal-close:hover {
//             background: #f5f5f5;
//             color: #000;
//           }

//           .trial-button {
//             background-color: #2a0947;
//             color: white;
//             padding: 14px 35px;
//             border: none;
//             border-radius: 8px;
//             font-size: 16px;
//             font-weight: 600;
//             cursor: pointer;
//             display: block;
//             margin: 20px auto 0;
//             transition: background-color 0.3s;
//             min-width: 140px;
//           }

//           .trial-button:hover {
//             background-color: #2a0947;
//           }

//           /* ✅ RESPONSIVE BREAKPOINTS FOR MODAL */
//           /* Large Desktops */
//           @media (min-width: 1440px) {
//             .modal-box {
//               max-width: 460px;
//               padding: 40px;
//             }
//           }

//           /* Desktops */
//           @media (min-width: 1200px) {
//             .modal-box {
//               max-width: 430px;
//               padding: 35px;
//             }
//           }

//           /* Tablets and Small Desktops */
//           @media (max-width: 1199px) and (min-width: 768px) {
//             .modal-box {
//               max-width: 415px;
//               padding: 30px;
//             }
//           }

//           /* Tablets */
//           @media (max-width: 768px) {
//             .modal {
//               padding: 15px;
//             }

//             .modal-box {
//               width: 95%;
//               max-width: 400px;
//               padding: 25px 20px;
//             }

//             .modal-close {
//               top: 12px;
//               right: 15px;
//               font-size: 24px;
//               width: 32px;
//               height: 32px;
//             }
//           }

//           /* Large Phones */
//           @media (max-width: 480px) {
//             .modal {
//               padding: 10px;
//               align-items: flex-start;
//               padding-top: 50px;
//             }

//             .modal-box {
//               width: 100%;
//               max-width: 350px;
//               padding: 25px 20px;
//               min-height: auto;
//             }

//             .modal-box input {
//               padding: 12px 14px;
//               margin-bottom: 14px;
//             }

//             .trial-button {
//               padding: 12px 30px;
//               font-size: 15px;
//               min-width: 120px;
//             }
//           }

//           /* Small Phones */
//           @media (max-width: 375px) {
//             .modal {
//               padding: 8px;
//               padding-top: 40px;
//             }

//             .modal-box {
//               padding: 20px 16px;
//               width: 100%;
//               max-width: 350px;
//             }

//             .modal-box h3 {
//               font-size: 18px;
//               margin-bottom: 20px;
//             }

//             .modal-box input {
//               padding: 11px 12px;
//               font-size: 15px;
//             }

//             .trial-button {
//               padding: 11px 25px;
//               font-size: 14px;
//             }
//           }

//           /* Very Small Phones */
//           @media (max-width: 320px) {
//             .modal-box {
//               padding: 18px 14px;
//               max-width: 300px;
//             }

//             .modal-box h3 {
//               font-size: 17px;
//             }

//             .modal-box input {
//               padding: 10px 12px;
//               font-size: 14px;
//             }
//           }

//           /* Landscape Mode */
//           @media (max-height: 600px) and (orientation: landscape) {
//             .modal {
//               align-items: flex-start;
//               padding-top: 20px;
//               padding-bottom: 20px;
//             }

//             .modal-box {
//               max-height: 90vh;
//               overflow-y: auto;
//               min-height: auto;
//             }
//           }

//           /* Very Tall Screens */
//           @media (min-height: 1000px) {
//             .modal-box {
//               max-width: 500px;
//               padding: 40px;
//             }
//           }
//         `}
//       </style>
//       <div className="main-container">
//         <h1
//           style={{
//             fontSize: "50px",
//             fontFamily: "Lato, sans-serif",
//             fontWeight: "bold",
//             color: "white",
//           }}
//         >
//           Everything You Need,{" "}
//           <span style={{ color: "rgb(255 225 36)" }}>One Tap Away</span>
//         </h1>

//         <div className="cards-container">
//           {cardData.map((card, index) => (
//             <div className="cardss" key={index}>
//               <div className="image-container">
//                 <img src={card.image} alt={card.location} />
//               </div>
//               <div className="description">{card.description}</div>

//               <button
//                 className="book-now-btn"
//                 onClick={() => openModal(card.verticalKey)}
//               >
//                 Book A Demo
//               </button>

//               {/* <div
//                 className="location-overlays"
//                 style={{ cursor: "pointer" }}
//                 onClick={() => navigate("/")}
//               >
//                 {card.location}
//               </div> */}
//             </div>
//           ))}
//         </div>
//         {isModalOpen && (
//           <div className="modal">
//             <div className="modal-box" style={{ top: "25%" }}>
//               <button className="modal-close" onClick={closeModal}>
//                 &times;
//               </button>
//               <h3 style={{ textAlign: "center", marginBottom: "25px", color: "#333" }}>
//                 Free Trial Form
//               </h3>
//               <form onSubmit={handleSubmit}>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   placeholder="Your Name"
//                   required
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   placeholder="Phone Number"
//                   required
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   placeholder="Email Address"
//                   required
//                 />
//                 <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//                   <button type="submit" className="trial-button">
//                     Explore
//                   </button>
//                 </div>

//                 {/* Login Link Section */}
//                 <div style={{
//                   textAlign: 'center',
//                   marginTop: '15px',
//                   paddingTop: '15px',
//                   borderTop: '1px solid #eee'
//                 }}>
//                   <p style={{
//                     fontSize: '14px',
//                     color: '#666',
//                     marginBottom: '8px'
//                   }}>
//                     Already have an account?
//                   </p>
//                   <button
//                     type="button"
//                     onClick={() => {
//                       closeModal();
//                       // This will trigger the login panel from Auth component
//                       // You'll need to pass a prop or use context/state management
//                       window.dispatchEvent(new CustomEvent('openLoginPanel'));
//                     }}
//                     style={{
//                       background: 'none',
//                       border: 'none',
//                       color: '#2a0947',
//                       textDecoration: 'underline',
//                       cursor: 'pointer',
//                       fontSize: '14px',
//                       fontWeight: '600',
//                       padding: '5px 10px'
//                     }}
//                   >
//                     Login here
//                   </button>
//                 </div>

//                 {loading && (
//                   <div style={{ marginTop: "15px", color: "#2a0947", textAlign: "center" }}>
//                     Loading, please wait...
//                   </div>
//                 )}
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default DemoBooking;



import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import hotelRoomImg1 from "../../../images/aaaservices/point-of-sale.webp";
import hotelRoomImg2 from "../../../images/products/products.png";
import hotelRoomImg3 from "../../../images/aaaservices/groceries.png";
import { useLoader } from "../../../context/LoaderProvider";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";


const cardData = [
  {
    image: hotelRoomImg1,
    location: "Food & Beverages",
    description:
      "From fine dining and quick-service restaurants to cafes, bakeries, juice bars, and specialty food stores, Maamaas empowers you to showcase your menu with stunning visuals, manage orders seamlessly—including dine-in, takeaway, and delivery—and reach more customers in your area to grow your brand.",
    verticalKey: "FOOD_AND_BEVERAGES",
  },
  // {
  //   image: hotelRoomImg2,
  //   location: "Catering & Services",
  //   description:
  //     "Whether you provide personal catering, corporate event catering, or operate a company cafeteria, Maamaas helps you present your catering packages and customized menu options to potential clients, accept bookings online effortlessly, and build trust through customer ratings and reviews.",
  //   verticalKey: "CATERINGS_SERVICES",
  // },
  // {
  //   image: hotelRoomImg3,
  //   location: "Fresh & Groceries",
  //   description:
  //     "From courier and delivery services to wholesale suppliers and inventory businesses, Maamaas streamlines your operations by managing orders efficiently, tracking deliveries and shipments in real time, and enabling smooth communication with customers and partners.",
  //   verticalKey: "FRESH_GROCERIES",
  // },
];


const DemoBooking = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const [vendorData, setVendorData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedVertical, setSelectedVertical] = useState("");
  const [emailCheckMessage, setEmailCheckMessage] = useState("");
  const [isSignup, setIsSignup] = useState(false);


  // Demo form state
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
  });

  // Login form state
  const [loginData, setLoginData] = useState({
    userName: "",
    password: "",
  });

  // Signup form state
  const [signupData, setSignupData] = useState({
    userName: "",
    emailId: "",
    password: "",
    mobileNumber: "",
  });

  // Forgot password state
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [signupError, setSignupError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [signupLoading, setSignupLoading] = useState(false);
  const [loginStepStarted, setLoginStepStarted] = useState(false);

  const openModal = (vertical) => {
    setSelectedVertical(vertical);
    setIsModalOpen(true);
  };
  const [loginObj, setLoginObj] = useState({
    userName: "",
    password: "",
  });

  const closeModal = () => setIsModalOpen(false);
  const openLoginModal = () => {
    setIsLoginModalOpen(true);
    setIsForgotPassword(false); // Reset forgot password state
  };
  const closeLoginModal = () => setIsLoginModalOpen(false);
  const openSignupModal = () => setIsSignupModalOpen(true);
  const closeSignupModal = () => setIsSignupModalOpen(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignupChange = (e) => {
    const { name, value } = e.target;
    setSignupData((prev) => ({ ...prev, [name]: value }));
  };

  // Forgot Password function
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!forgotEmail) {
      alert("Please enter your email");
      return;
    }

    setForgotLoading(true);
    setForgotMessage("");

    try {
      const response = await fetch(
        `https://backend.maamaas.com/subscription/api/auth/vendor/reset-password?identifier=${encodeURIComponent(forgotEmail)}`,
        {
          method: "PUT",
          headers: {
            Accept: "*/*",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Password reset failed");
      }

      setForgotMessage("Password reset link has been sent to your email!");
      setForgotEmail("");
    } catch (err) {
      console.error("❌ Error resetting password:", err);
      setForgotMessage("Reset password link sent to your mail!");
    } finally {
      setForgotLoading(false);
    }
  };

  // Login function
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginLoading(true);
    setLoginError("");

    try {
      const url = `https://backend.maamaas.com/subscription/api/auth/login/vendor?identifier=${encodeURIComponent(
        loginData.userName
      )}&password=${encodeURIComponent(loginData.password)}`;

      const response = await fetch(url, {
        method: "POST",
        headers: { Accept: "*/*" },
        body: "",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }

      console.log("✅ Login API response:", data);

      // Clear previous login data
      localStorage.clear();

      // Store fields
      localStorage.setItem("authToken", data.token || "");
      localStorage.setItem("refreshToken", data.refreshToken || "");
      localStorage.setItem("userId", data.userId?.toString() || "");
      localStorage.setItem("vendorId", data.vendorId?.toString() || "");
      localStorage.setItem("role", data.role || "");
      localStorage.setItem("employeRole", data.employeRole || "");
      localStorage.setItem("employeeId", data.employeeId?.toString() || "");

      // Store planTypes as JSON string
      if (Array.isArray(data.planTypes)) {
        localStorage.setItem("planTypes", JSON.stringify(data.planTypes));
        console.log("📦 Stored planTypes:", data.planTypes);
      } else {
        localStorage.setItem("planTypes", JSON.stringify([]));
      }

      // Store businessVerticals as JSON
      if (Array.isArray(data.businessVerticals)) {
        localStorage.setItem("businessVerticals", JSON.stringify(data.businessVerticals));
      } else {
        localStorage.setItem("businessVerticals", JSON.stringify([]));
      }

      // Optional: store full response
      localStorage.setItem("loginResponse", JSON.stringify(data));

      alert("Login successful!");
      closeLoginModal();
      // navigate("/foodladingpage");
      navigate("/foodbeveragescompany");

    } catch (err) {
      console.error("❌ Login error:", err);
      setLoginError("Login failed: " + err.message);
    } finally {
      setLoginLoading(false);
    }
  };

  // Signup function
  const handleSignup = async (e) => {
    e.preventDefault();
    setSignupLoading(true);
    setSignupError("");

    const requestBody = {
      userName: signupData.userName,
      emailId: signupData.emailId,
      password: signupData.password,
      mobileNumber: signupData.mobileNumber,
      role: "ADMIN",
    };

    alert(`Role being sent: ${requestBody.role}`);

    const apiUrl = "http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/user/registration";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        alert("Signup successful!");
        closeSignupModal();
        navigate("/home");
      } else {
        const result = await response.json();
        setSignupError(result.message || "Signup failed");
      }
    } catch (error) {
      setSignupError("Something went wrong. Please try again.");
    }

    setSignupLoading(false);
  };
  const handleChange = (e) => {
    setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Required fields check
      if (!formData.name || !formData.email || !formData.phone || !formData.city) {
        showCustomAlert("Please fill in all required fields (Name, Email, Phone, City).");
        return;
      }

      // Name validation
      if (!formData.name.trim()) {
        showCustomAlert("Please enter your name.");
        return;
      }

      if (formData.name.trim().length < 2) {
        showCustomAlert("Please enter a valid name (at least 2 characters).");
        return;
      }

      if (!/^[a-zA-Z\s]+$/.test(formData.name.trim())) {
        showCustomAlert("Name should contain only letters and spaces.");
        return;
      }

      // Email validation
      // Allows common professional domains
      const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@(gmail|yahoo|outlook|hotmail|companyname|yourbusiness|envisionis)\.(com|in|org|net)$/;
      if (!emailRegex.test(formData.email)) {
        showCustomAlert("Please enter a valid email address (format: name@domain.com).");
        return;
      }

      // Phone validation (more flexible)
      const cleanPhone = formData.phone.replace(/\D/g, '');
      const phoneRegex = /^[0-9]{10}$/;

      if (!phoneRegex.test(cleanPhone)) {
        showCustomAlert("Please enter a valid 10-digit phone number.");
        return;
      }

      // City validation
      if (!formData.city.trim()) {
        showCustomAlert("Please enter your city.");
        return;
      }

      if (formData.city.trim().length < 2) {
        showCustomAlert("Please enter a valid city name (at least 2 characters).");
        return;
      }

      // More flexible city validation (allows numbers, hyphens, apostrophes)
      if (!/^[a-zA-Z\s\-']+$/.test(formData.city.trim())) {
        showCustomAlert("Please enter a valid city name (letters, spaces, hyphens and apostrophes only).");
        return;
      }
      // Create payload
      // const payload = {
      //   vendorId: 0,
      //   name: formData.name.trim(),
      //   email: formData.email.trim(),
      //   mobileNumber: cleanPhone,
      //   city: formData.city.trim(),
      //   parentId: null,
      //   companyName: "",
      //   username: formData.email.trim(),
      //   password: "tempPassword123",
      //   enabled: true,
      //   role: "ROLE_VENDOR",
      //   businessVerticals: [selectedVertical],
      //   registerTime: new Date().toISOString(),
      //   employeRole: "Manager",
      //   businessModules: ["Home"],
      //   credentialsNonExpired: true,
      //   accountNonExpired: true,
      //   accountNonLocked: true
      // };
      const payload = {
        vendorId: vendorData?.vendorId || 0,
        parentId: null,
        name: formData.name.trim(),
        email: formData.email.trim(),
        city: formData.city.trim(),
        mobileNumber: formData.phone.trim(),
        role: "ROLE_VENDOR",
        businessVerticals: [selectedVertical],
        registerTime: ""
      };

      showLoader();

      const res = await fetch(
        "https://backend.maamaas.com/subscription/api/vendor/enquiry",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const responseText = await res.text();
      let responseData = {};

      try {
        responseData = responseText ? JSON.parse(responseText) : {};
      } catch (parseError) {
        console.error("❌ JSON parse error:", parseError);
      }

      setLoading(false);

      if (!res.ok) {
        console.error("❌ Server error response:", {
          status: res.status,
          statusText: res.statusText,
          responseText: responseText,
          responseData: responseData
        });

        const errorMessage = responseData.message || responseText || "Unknown error occurred";
        const lowerCaseMessage = errorMessage.toLowerCase();

        // Very specific error detection
        if (res.status === 400 || res.status === 409 || res.status === 500) {

          // Email-specific patterns
          const emailPatterns = [
            /email.*already/i,
            /email.*exist/i,
            /username.*already/i,
            /username.*exist/i,
            /duplicate.*email/i,
            /email.*duplicate/i,
            /email.*registered/i
          ];

          // Phone-specific patterns
          const phonePatterns = [
            /phone.*already/i,
            /phone.*exist/i,
            /mobile.*already/i,
            /mobile.*exist/i,
            /number.*already/i,
            /number.*exist/i,
            /duplicate.*phone/i,
            /duplicate.*mobile/i,
            /phone.*duplicate/i,
            /mobile.*duplicate/i,
            /phone.*registered/i,
            /mobile.*registered/i
          ];

          const isEmailError = emailPatterns.some(pattern => pattern.test(errorMessage));
          const isPhoneError = phonePatterns.some(pattern => pattern.test(errorMessage));

          if (isEmailError && isPhoneError) {
            showCustomAlert("The email and phone number are already registered. Please use different credentials.");
          } else if (isEmailError) {
            showCustomAlert("This email is already registered. Please use a different email or login.");
          } else if (isPhoneError) {
            showCustomAlert("This phone number is already registered. Please use a different phone number or login .");
          } else if (lowerCaseMessage.includes("duplicate") || lowerCaseMessage.includes("already exist")) {
            showCustomAlert("This account already exists. Please use different email or phone number or login using the credentials.");
          } else {
            showCustomAlert(`Submission failed: ${errorMessage}`);
          }
        } else {
          showCustomAlert(`Submission failed: ${errorMessage}`);
        }
        return;
      }

      if (responseData.vendorId) {
        localStorage.setItem("vendorId", responseData.vendorId);
      }

      showCustomAlert("✅ Enquiry submitted successfully!");
      setFormData({ name: "", phone: "", email: "", city: "" });
      closeModal();
      navigate("/subscriptionpage");
    } catch (err) {
      setLoading(false);
      console.error("❌ Network error submitting form:", err);

      if (err.message.toLowerCase().includes("network") ||
        err.message.toLowerCase().includes("failed")) {
        showCustomAlert("Network error. Please check your connection and try again.");
      } else {
        showCustomAlert("Something went wrong. Please try again later.");
      }
    } finally {
      hideLoader();
    }
  };

  // Custom alert function (add this if not already present)
  const showCustomAlert = (message) => {
    // Remove any existing alerts first
    const existingAlert = document.querySelector('.custom-alert-overlay');
    if (existingAlert) {
      document.body.removeChild(existingAlert);
    }

    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'custom-alert-overlay';
    overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  `;

    // Create alert box
    const alertBox = document.createElement('div');
    alertBox.className = 'custom-alert-box';
    alertBox.style.cssText = `
    background: white;
    padding: 30px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
    max-width: 400px;
    width: 90%;
    animation: fadeIn 0.3s ease;
  `;

    // Create message
    const messageEl = document.createElement('p');
    messageEl.className = 'custom-alert-message';
    messageEl.textContent = message;
    messageEl.style.cssText = `
    margin: 0 0 25px 0;
    font-size: 16px;
    color: #333;
    line-height: 1.5;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  `;

    // Create OK button
    const okButton = document.createElement('button');
    okButton.className = 'custom-alert-button';
    okButton.textContent = 'OK';
    okButton.style.cssText = `
    background: #2a0947;
    color: white;
    border: none;
    padding: 12px 35px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  `;

    okButton.onmouseover = () => {
      okButton.style.backgroundColor = '#1a0630';
    };

    okButton.onmouseout = () => {
      okButton.style.backgroundColor = '#2a0947';
    };

    okButton.onclick = () => {
      document.body.removeChild(overlay);
    };

    // Add CSS for animation if not already present
    if (!document.querySelector('#custom-alert-styles')) {
      const style = document.createElement('style');
      style.id = 'custom-alert-styles';
      style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
      document.head.appendChild(style);
    }

    // Assemble and show
    alertBox.appendChild(messageEl);
    alertBox.appendChild(okButton);
    overlay.appendChild(alertBox);
    document.body.appendChild(overlay);

    // Close on overlay click
    overlay.onclick = (e) => {
      if (e.target === overlay) {
        document.body.removeChild(overlay);
      }
    };

    // Close on Escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        document.body.removeChild(overlay);
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);

    // Clean up event listener when alert is closed
    overlay.addEventListener('click', function handler(e) {
      if (e.target === overlay || e.target === okButton) {
        document.removeEventListener('keydown', handleEscape);
      }
    });
    setTimeout(() => {
      if (document.body.contains(overlay)) {
        document.body.removeChild(overlay);
      }
    }, 2000);
  };
  
  const handleEmailCheck = async (e) => {
    e.preventDefault();
    const email = loginObj.emailId?.trim();

    if (!email) {
      alert("Please enter a valid email.");
      return;
    }

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/subscription/api/vendor/enquiry/get-email`,
        {
          params: { emailId: email },
        }
      );

      console.log("✅ API Full Response:", response.data);
      const vendorData = response.data;

      if (vendorData?.vendorId) {
        localStorage.setItem("vendorId", vendorData.vendorId);
        alert("✅ Email verified and vendor ID stored.");
        navigate("/subscriptionpage");
      } else {
        console.warn("⚠️ No vendorId found in API response.");
        alert("Vendor not found. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error during email check:", error.response?.data || error.message);
      alert("Failed to check email. Please try again.");
    }
  };


  return (
    <section id="what-we-do">
      <style>
        {`
          .main-container {
            background-color:#2a0947;
            color: #fff;
            padding: 20px;
            text-align: center;
            margin-top:20px;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          }

          .cards-container {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            gap: 20px;
            padding: 20px 0;
          }

          /* ✅ For large screens (above 1000px) — show 3 cards per row */
          @media (min-width: 1000px) {
            .cardss {
              width: calc(33.33% - 40px);
              max-width: 350px;
            }
          }

          /* ✅ Between 768px–999px — 2 cards per row */
          @media (min-width: 768px) and (max-width: 999px) {
            .cardss {
              width: calc(50% - 30px);
            }
          }

          /* ✅ Below 768px — 1 card per row */
          @media (max-width: 767px) {
            .cardss {
              width: 100%;
            }
          }

          .cardss {
            background: #fff;
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;
            padding: 20px 10px;
            color: #000;
            position: relative;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }

          .image-container {
            width: 100%;
            height: 180px;
          }

          .image-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 12px;
          }

          .description {
            padding: 10px 0;
            font-size: 14px;
            text-align: center;
            min-height: 60px;
            font-weight: bold;
          }

          .location-overlays {
            position: absolute;
            bottom: 19px;
            left: 30%;
            transform: translateX(-50%);
            background: #2a0947;
            color: white;
            padding: 8px 8px;
            border-radius: 10px;
            font-size: 14px;
            font-weight: bold;
            z-index: 1;
            transition: background 0.3s, color 0.3s;
          }

          .location-overlays:hover {
            background: #ffbe64;
            color: black;
          }

          .book-now-btn {
            margin-top: auto;
            padding: 8px 6px;
            background: #2a0947;
            color: rgb(255 225 36);
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-weight: bold;
            cursor: pointer;
          }

          .book-now-btn:hover {
            background-color: #2a0947;
            color: white;
          }

          /* ✅ IMPROVED MODAL STYLES - FULLY RESPONSIVE */
          .modal {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.5);
            width: 100vw;
            height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
            padding: 20px;
            box-sizing: border-box;
          }

          .modal-box {
            background: #fff;
            color: #000;
            padding: 30px;
            border-radius: 12px;
            width: 90%;
            max-width: 450px;
            min-height: 200px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.3);
            position: relative;
            margin: 0 auto;
          }

          .modal-box input {
            width: 100%;
            padding: 14px 16px;
            margin-bottom: 16px;
            border-radius: 8px;
            border: 1px solid #ddd;
            box-sizing: border-box;
            font-size: 16px;
            transition: border-color 0.3s;
          }

          .modal-box input:focus {
            border-color: #2a0947;
            outline: none;
          }

          .modal-close {
            position: absolute;
            top: 15px;
            right: 20px;
            font-size: 28px;
            background: none;
            border: none;
            cursor: pointer;
            color: #666;
            width: 35px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.3s;
          }

          .modal-close:hover {
            background: #f5f5f5;
            color: #000;
          }

          .trial-button {
            background-color: #2a0947;
            color: white;
            padding: 14px 35px;
            border: none;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
            display: block;
            margin: 10px auto 0;
            transition: background-color 0.3s;
            min-width: 140px;
            width:100%;
          }

          .trial-button:hover {
            background-color: #2a0947;
          }

          .auth-button {
            background-color: #2a0947;
            color: white;
            padding: 12px 35px;
            border: none;
            border-radius: 6px;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            display: block;
            margin: 20px auto 0;
            transition: background-color 0.3s;
            min-width: 140px;
            width: 100%;
          }

          .auth-button:hover {
            background-color: #2a0947;
          }

          .auth-button:disabled {
            background-color: #cccccc;
            cursor: not-allowed;
          }

          .password-input-container {
            position: relative;
            width: 100%;
            // margin-bottom: 16px;
          }

          .password-input-container input {
            width: 100%;
            padding-right: 40px;
          }

          .password-toggle {
            position: absolute;
            right: 12px;
            top: 35%;
            transform: translateY(-50%);
            background: none;
            border: none;
            color: #666;
            cursor: pointer;
            padding: 4px;
          }

          .auth-switch-text {
            text-align: end;
            // margin-top: 15px;
            // padding-top: 1px;
            // border-top: 1px solid #eee;
          }

          .auth-switch-button {
            background: none;
            border: none;
            color: #007bff;
            text-decoration: underline;
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
            padding: 0px 10px;
          }

          .forgot-password-link {
            text-align: right;
            margin-bottom: -10px;
          }

          .forgot-password-link button {
            background: none;
            border: none;
            color: #007bff;
            font-size: 14px;
            text-decoration: none;
            cursor: pointer;
          }

          .forgot-password-link button:hover {
            text-decoration: underline;
          }

          /* RESPONSIVE BREAKPOINTS FOR MODAL */
          @media (max-width: 768px) {
            .modal {
              padding: 15px;
            }
            
            .modal-box {
              width: 95%;
              max-width: 450px;
              padding: 25px 20px;
            }
            
            .modal-close {
              top: 12px;
              right: 15px;
              font-size: 24px;
              width: 32px;
              height: 32px;
            }
          }

          @media (max-width: 480px) {
            .modal {
              padding: 10px;
              align-items: flex-start;
              padding-top: 50px;
            }
            
            .modal-box {
              width: 100%;
              max-width: 400px;
              padding: 25px 20px;
              min-height: auto;
            }
            
            .modal-box input {
              padding: 12px 14px;
              margin-bottom: 14px;
            }
            
            .trial-button, .auth-button {
              padding: 12px 30px;
              font-size: 15px;
              min-width: 120px;
            }
          }
            .custom-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.custom-alert-box {
  background: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
  max-width: 400px;
  width: 90%;
  animation: fadeIn 0.3s ease;
}

.custom-alert-message {
  margin: 0 0 25px 0;
  font-size: 16px;
  color: #333;
  line-height: 1.5;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.custom-alert-button {
  background: #2a0947;
  color: white;
  border: none;
  padding: 12px 35px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.custom-alert-button:hover {
  background: #1a0630;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}
        `}
      </style>
      <div className="main-container">
        <h1
          style={{
            fontSize: "50px",
            fontFamily: "Lato, sans-serif",
            fontWeight: "bold",
            color: "white",
          }}
        >
          Everything You Need,{" "}
          <span style={{ color: "rgb(255 225 36)" }}>One Tap Away</span>
        </h1>

        <div className="cards-container">
          {cardData.map((card, index) => (
            <div className="cardss" key={index}>
              <div className="image-container">
                <img src={card.image} alt={card.location} />
              </div>
              <div className="description">{card.description}</div>

              <button
                className="book-now-btn"
                onClick={() => openModal(card.verticalKey)}
              >
                Book A Demo
              </button>
            </div>
          ))}
        </div>

        {/* Demo Modal */}
        {isModalOpen && (
          <div className="modal">
            <div className="modal-box" style={{ top: "25%" }}>
              <button className="modal-close" onClick={closeModal}>
                &times;
              </button>
              <h3 style={{ textAlign: "center", marginBottom: "25px", color: "#333" }}>
                Free Trial Form
              </h3>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email Address"
                  required
                />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Phone Number"
                  required
                />
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  placeholder="Enter Your City"
                  required
                />

                {/* Login Link Section */}
                <div className="auth-switch-text">
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    marginBottom: '0px'
                  }}>
                    Already have an account?
                  </p>
                  <button
                    type="button"
                    onClick={() => {
                      closeModal();
                      openLoginModal();
                    }}
                    className="auth-switch-button"
                  >
                    Login here with MailId
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center", }}>
                  <button type="submit" className="trial-button">
                    Explore
                  </button>
                </div>



                {loading && (
                  <div style={{ marginTop: "15px", color: "#2a0947", textAlign: "center" }}>
                    Loading, please wait...
                  </div>
                )}
              </form>
            </div>
          </div>
        )}

        {/* Login Modal */}
        {isLoginModalOpen && (
          <div className="modal">
            <div className="modal-box" style={{ top: "25%" }}>
              <button className="modal-close" onClick={closeLoginModal}>
                &times;
              </button>

              {/* Welcome Header */}
              <p style={{
                marginBottom: '20px',
                fontFamily: 'revert',
                fontSize: '22px',
                color: '#2a0947',
                fontWeight: 'bold',
                textAlign: 'center'
              }}>
                WELCOME TO MAAMAA'S
              </p>


              {!loginStepStarted && !isForgot && (
                <>
                  <form onSubmit={handleEmailCheck} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <input
                      type="email"
                      placeholder="Enter your Email to Start"
                      name="emailId"
                      value={loginObj.emailId}
                      onChange={handleChange}
                      required
                      style={{
                        padding: '10px',
                        fontSize: '16px',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                      }}
                    />
                    <button
                      type="submit"
                      style={{
                        backgroundColor: 'rgb(42 9 71)',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '12px',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                      }}
                    >
                      Check & Save
                    </button>
                  </form>

                  {/* {emailCheckMessage && <p style={{ marginTop: '10px', color: 'green' }}>{emailCheckMessage}</p>}
                  <p style={{ marginTop: '10px', fontSize: '14px' }}>
                    Already signed up?{' '}
                    <span
                      onClick={() => {
                        setIsSignup(false);
                        setLoginStepStarted(true);
                      }}
                      style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                      Login here
                    </span>
                  </p> */}
                </>
              )}
            </div>
          </div>
        )}

        {/* Signup Modal */}
        {isSignupModalOpen && (
          <div className="modal">
            <div className="modal-box" style={{ top: "25%" }}>
              <button className="modal-close" onClick={closeSignupModal}>
                &times;
              </button>
              <h3 style={{ textAlign: "center", marginBottom: "25px", color: "#333" }}>
                Create New Account
              </h3>
              <form onSubmit={handleSignup}>
                <input
                  type="text"
                  name="userName"
                  value={signupData.userName}
                  onChange={handleSignupChange}
                  placeholder="Username"
                  required
                />
                <input
                  type="email"
                  name="emailId"
                  value={signupData.emailId}
                  onChange={handleSignupChange}
                  placeholder="Email Address"
                  required
                />
                <input
                  type="tel"
                  name="mobileNumber"
                  value={signupData.mobileNumber}
                  onChange={handleSignupChange}
                  placeholder="Mobile Number"
                  required
                />

                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={signupData.password}
                    onChange={handleSignupChange}
                    placeholder="Password"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>

                {signupError && (
                  <div style={{ color: 'red', marginBottom: '15px', textAlign: 'center' }}>
                    {signupError}
                  </div>
                )}

                <button
                  type="submit"
                  className="auth-button"
                  disabled={signupLoading}
                >
                  {signupLoading ? 'Signing up...' : 'SIGN UP'}
                </button>

                <div className="auth-switch-text">
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    marginBottom: '8px'
                  }}>
                    Already have an account?
                  </p>
                  <button
                    type="button"
                    onClick={() => {
                      closeSignupModal();
                      openLoginModal();
                    }}
                    className="auth-switch-button"
                  >
                    Login here
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DemoBooking;